import React from "react";
import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageBits";
import LeadForm from "@/components/LeadForm";
import { Gift, Truck, Leaf } from "lucide-react";

export default function Sample() {
  useSEO({ title: "Request a Free Sample", description: "Try before you buy. Request a free sample of Leaf Alchemy premium tea powder for your business." });

  return (
    <div data-testid="sample-page">
      <PageHero eyebrow="Try Before You Buy" title="Request a Free Sample"
        image="https://images.unsplash.com/photo-1764813823915-7eb0b1286076?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
        subtitle="Taste the Leaf Alchemy difference. We'll send a sample so you can experience the quality first-hand." />

      <section className="py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2 space-y-6">
            {[
              { icon: Gift, t: "Complimentary Sample", d: "Experience our blends risk-free." },
              { icon: Leaf, t: "Choose Your Blend", d: "Sample the product that fits your business." },
              { icon: Truck, t: "Delivered to You", d: "Quick dispatch to your doorstep." },
            ].map((x) => (
              <Reveal key={x.t}>
                <div className="flex gap-4">
                  <div className="w-11 h-11 rounded-xl bg-forest/10 grid place-items-center text-forest shrink-0"><x.icon size={20} /></div>
                  <div>
                    <h4 className="font-display text-lg text-forest">{x.t}</h4>
                    <p className="text-sm text-muted-foreground">{x.d}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15} className="lg:col-span-3">
            <div className="bg-cream border border-gold/30 rounded-2xl p-7 shadow-[0_16px_48px_rgba(15,81,50,0.08)]" data-testid="sample-form-card">
              <h3 className="font-display text-2xl text-forest mb-1">Sample Request</h3>
              <p className="text-sm text-muted-foreground mb-5">Where should we send your sample?</p>
              <LeadForm type="sample" fields={["name", "phone", "email", "company", "city", "product", "message"]} submitLabel="Send Me a Sample" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
